import { FilterContext } from "@/types/queryInitInfo"
import { OnLiveEvents } from "@/types/sports"

interface EventLabelFilter extends FilterContext {
  onClick: (filter: EventLabelFilter) => void
  icon: string
  mode: "custom" | "eventType"
}

const useNavbarStore = defineStore("navbar", () => {
  const eventLabel = ref<FilterContext[]>([])
  const onLiveEventsList = ref(new Map())

  const selectItem = ref<EventLabelFilter | null>(null)
  const handleChangeNavbarSelect = <T extends EventLabelFilter>(item: T) => {
    if (selectItem.value === item) return

    selectItem.value = item
  }

  const clearSelectItem = () => {
    selectItem.value = null
  }

  const updateEventLabel = (list: FilterContext[]) => {
    eventLabel.value = list
  }

  const updateOnLiveEventsList = (data: OnLiveEvents) => {
    onLiveEventsList.value = data.reduce((hash, node) => {
      hash.set(node.eventType, node.count)

      return hash
    }, new Map())
  }

  return {
    selectItem,
    eventLabel,
    onLiveEventsList,
    updateOnLiveEventsList,
    updateEventLabel,
    clearSelectItem,
    handleChangeNavbarSelect
  }
})

export default useNavbarStore
